<script setup>

    // ShipMethodSelector
    // Shows shipping methods and provides the ability to pick one.

    // Imports ----
    import { defineProps, defineEmits, computed } from 'vue';
    import { store } from '@/Store';
    import { v4 as uuidv4 } from 'uuid';

    // Props ----
    const props = defineProps({
        // Code for the ship method
        modelValue: {
            type: String,
            required: false,
            default: null
        },
        defaultValue: {
            type: String,
            required: false,
            default: null
        },
    });

    // State ----
    const emit = defineEmits(['update:modelValue']);
    const listId = uuidv4();

    // Computed ----
    const shipMethods = computed(() => {
        return store.shipping.methods;
    });

    const selected = computed({
        get() {
            return props.modelValue;
        },
        set(value) {
            emit('update:modelValue', value);
        }
    });

    // Handlers ----
    function onShipMethodChanged() {
        store.cart.setShipMethod(selected.value);
    }


</script>

<template>

    <div class="ship-method-selector">

        <div v-for="method in shipMethods" :key="method.code" class="form-check mb-1">
            <div class="d-flex">
                <div class="d-flex flex-row">
                    <div class="radio-container align-self-center">
                        <input v-model="selected" class="form-check-input" type="radio" :name="listId" :id="method.code" :value="method.code" @change="onShipMethodChanged()">
                    </div>
                </div>
                <div class="d-flex flex-row flex-fill">
                    <div class="label-container align-self-center">
                        <label class="form-check-label" :for="method.code">
                            {{ method.name }}
                        </label>
                        <slot v-bind="method"></slot>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<style lang="scss">

    .ship-method-selector {
        input[type=radio] {
            width: 1.2rem;
            height: 1.2rem;
            margin-top: -0.1rem;
        }

        .label-container {
            margin-left: 0.5rem;
        }
    }
</style>